"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[823],{

/***/ 73823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ SortDropdown; },
/* harmony export */   "Z": function() { return /* binding */ OrdersOverview; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var src_themes_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69431);
/* harmony import */ var remixicon_react_FileDownloadLineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51026);
/* harmony import */ var remixicon_react_FileDownloadLineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_FileDownloadLineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(72977);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69293);
/* harmony import */ var src_context_UserContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76336);
/* harmony import */ var src_api_rest__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73565);
/* harmony import */ var src_components_common_Loader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(965);
/* harmony import */ var src_components_typography_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56795);
/* harmony import */ var src_components_buttons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31494);
/* harmony import */ var src_utils_numbers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(60165);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41145);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(186);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(54572);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(52287);
/* harmony import */ var react_date_picker__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(63623);
/* harmony import */ var react_date_picker_dist_DatePicker_css__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(84613);
/* harmony import */ var react_date_picker_dist_DatePicker_css__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(react_date_picker_dist_DatePicker_css__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_calendar_dist_Calendar_css__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(45787);
/* harmony import */ var react_calendar_dist_Calendar_css__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(react_calendar_dist_Calendar_css__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var src_const__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(38597);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  margin-left: 80px;\n  @media (max-width: 750px) {\n    margin: 0px;\n  }\n  .orders-conatiner {\n    margin-top: 30px;\n    background-color: ",
        ";\n    border-radius: 0px 5px 5px 5px;\n    padding: 40px;\n    padding-bottom: 80px;\n    @media (max-width: 750px) {\n      padding: 0px;\n    }\n  }\n  .heading-sort {\n    display: flex;\n    justify-content: space-between;\n\n    @media screen and (max-width: 768px) {\n      flex-direction: column;\n      gap: 10px;\n      justify-content: flex-start;\n      align-items: flex-start;\n    }\n  }\n  .download-button {\n    background-color: transparent;\n    border: none !important;\n    :hover {\n      svg {\n        color: ",
        ";\n      }\n    }\n    :active {\n      svg {\n        color: ",
        ";\n      }\n    }\n  }\n  .column {\n    display: flex;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n    @media screen and (max-width: 768px) {\n      padding-right: 5px;\n      padding-left: 5px;\n    }\n    .loader {\n      margin: 0px 0px;\n      height: 35px;\n      @media screen and (max-width: 768px) {\n        height: 25px;\n      }\n    }\n  }\n  .align {\n    width: 100%;\n    word-wrap: break-word;\n    @media screen and (max-width: 768px) {\n      font-size: 12px;\n    }\n  }\n  .orders-table {\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    padding: 0px 20px;\n    border-radius: 5px 5px 0px 0px;\n    @media (max-width: 750px) {\n      padding: 0px 10px;\n    }\n  }\n  .header {\n    font-size: 600;\n    font-weight: bold;\n    @media screen and (max-width: 768px) {\n      font-size: 12px;\n    }\n  }\n  .row {\n    border-bottom: 1px solid ",
        ";\n    padding-bottom: 15px;\n    padding-top: 15px;\n  }\n  .table-row {\n    cursor: pointer;\n    :hover {\n      color: ",
        ";\n    }\n  }\n  .message_box {\n    margin: auto;\n    padding: 10px;\n    font-size: 20px;\n    color: ",
        ";\n  }\n  .load_button {\n    float: right;\n    margin-top: 35px;\n    margin-right: 10px;\n  }\n  .loader {\n    margin-top: 30px;\n    margin-left: 30px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      position: relative;\n      top: 0;\n      border-top: border-top: 1px solid ",
        ";\n      border-bottom: none !important;\n      border-left: none !important;\n      border-right: none;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 3px 6px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 99;\n  min-width: 300px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n  border-radius: 5px;\n  border: 2px solid ",
        ";\n  .sort-button {\n    background-color: transparent;\n    border: none !important;\n    outline: none !important;\n    width: 100%;\n    min-width: 300px;\n    height: 40px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    span {\n      font-size: 16px;\n      flex-grow: 1;\n      display: flex;\n      justify-content: flex-start;\n      font-weight: 500;\n    }\n  }\n\n  .options {\n    width: 100%;\n    position: absolute;\n    top: 45px;\n    z-index: 99;\n    border: 2px solid ",
        ";\n    background-color: ",
        ";\n    ",
        "\n    li {\n      padding: 5px;\n      button {\n        width: 100%;\n        text-align: left;\n        background-color: transparent;\n        border: none !important;\n        font-size: 16px;\n        &:hover {\n          color: ",
        ";\n        }\n        .selected {\n          button {\n            color: ",
        ";\n          }\n        }\n      }\n      &:hover {\n        cursor: pointer;\n      }\n    }\n  }\n\n  @media screen and (max-width: 768px) {\n    width: 100%;\n    position: relative;\n  }\n  align-self: flex-end;\n  margin-bottom: 10px;\n  .arrow {\n    border: solid black;\n    border-width: 0 3px 3px 0;\n    display: inline-block;\n    padding: 3px;\n  }\n  .up {\n    transform: rotate(-135deg);\n    -webkit-transform: rotate(-135deg);\n  }\n  .down {\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n  }\n\n  .sort-calendar-icon {\n    margin-right: 10px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999999999;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  background: white;\n  padding: 50px;\n  min-width: 50%;\n  position: relative;\n\n  @media screen and (max-width: 1240px) {\n    min-width: 80%;\n  }\n\n  .close-button {\n    position: absolute;\n    border: 1px solid black;\n    font-weight: 700;\n    top: 0;\n    right: 0;\n    padding: 15px;\n    background-color: #cbcbcb;\n  }\n\n  .date-heading {\n    font-size: 28px;\n    font-weight: 700;\n    line-height: 52px;\n    letter-spacing: 0em;\n    text-align: center;\n  }\n\n  .date-section {\n    font-weight: 700;\n    margin: 10px 0px;\n    p {\n      margin-bottom: 10px;\n    }\n    p.date-error-text {\n      color: #ef3f57;\n      font-weight: normal;\n      margin: 10px 0;\n    }\n  }\n\n  .btns-container {\n    margin-top: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    gap: 10px;\n\n    > button {\n      padding: 15px 10px;\n      background-color: transparent;\n      width: 50%;\n      border: 1px solid gray;\n      outline: none;\n      text-align: center;\n      font-weight: 700;\n      font-size: 18px;\n    }\n  }\n\n  .react-date-picker {\n    width: 100%;\n  }\n\n  .react-date-picker__wrapper {\n    padding: 8px;\n  }\n  .react-date-picker__clear-button {\n    display: none;\n  }\n  .react-date-picker__calendar-button {\n    order: 1;\n  }\n  .react-date-picker__inputGroup {\n    order: 2;\n  }\n\n  .react-calendar__tile--active {\n    background: none;\n    border: 1px solid red;\n    color: red;\n    border-radius: 5px;\n  }\n\n  .react-calendar__tile--active:enabled:hover {\n    background: #cbcbcb;\n  }\n\n  .react-calendar__month-view__days__day--weekend {\n    color: black;\n  }\n\n  button:disabled {\n    opacity: 0.7;\n    background: #cbcbcb;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

/* eslint-disable no-nested-ternary */ /* eslint-disable @next/next/no-img-element */ /* eslint-disable react/button-has-type */ /* eslint-disable no-console */ 


















var OrdersContainer = styled_components__WEBPACK_IMPORTED_MODULE_16__["default"].div(_templateObject(), src_themes_theme__WEBPACK_IMPORTED_MODULE_3__/* ["default"].palette.white */ .Z.palette.white, src_themes_theme__WEBPACK_IMPORTED_MODULE_3__/* ["default"].palette.error */ .Z.palette.error, src_themes_theme__WEBPACK_IMPORTED_MODULE_3__/* ["default"].palette.error */ .Z.palette.error, src_themes_theme__WEBPACK_IMPORTED_MODULE_3__/* ["default"].palette.white */ .Z.palette.white, src_themes_theme__WEBPACK_IMPORTED_MODULE_3__/* ["default"].palette.black20 */ .Z.palette.black20, src_themes_theme__WEBPACK_IMPORTED_MODULE_3__/* ["default"].palette.black20 */ .Z.palette.black20, (0,styled_tools__WEBPACK_IMPORTED_MODULE_11__/* .palette */ .DG)("error"), src_themes_theme__WEBPACK_IMPORTED_MODULE_3__/* ["default"].palette.red */ .Z.palette.red);
var SortDropdown = styled_components__WEBPACK_IMPORTED_MODULE_16__["default"].div(_templateObject2(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_11__/* .palette */ .DG)("white"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_11__/* .palette */ .DG)("black"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_11__/* .palette */ .DG)("black"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_11__/* .palette */ .DG)("white"), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_12__.media.lg(_templateObject1(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_11__/* .palette */ .DG)("black")), src_themes__WEBPACK_IMPORTED_MODULE_13__/* .theme.palette.error */ .r.palette.error, src_themes__WEBPACK_IMPORTED_MODULE_13__/* .theme.palette.error */ .r.palette.error);
var ModalOverlay = styled_components__WEBPACK_IMPORTED_MODULE_16__["default"].div(_templateObject3());
var ModalContent = styled_components__WEBPACK_IMPORTED_MODULE_16__["default"].div(_templateObject4());
var options = {
    new: "N\xfdjast",
    old: "Elst",
    this_month: "\xcd \xfeessum m\xe1nu\xf0i",
    last_month: "\xcd s\xed\xf0asta m\xe1nu\xf0i",
    last_three_months: "S\xed\xf0ustu 3 m\xe1nu\xf0ir",
    last_six_months: "S\xed\xf0ustu 6 m\xe1nu\xf0ir",
    this_year: "\xdeetta \xe1r",
    last_year: "S\xed\xf0asta \xe1r",
    all: "Allt",
    custom_range: "Velja t\xedmabil"
};
var dateOptions = [
    "this_month",
    "last_month",
    "last_three_months",
    "last_six_months",
    "this_year",
    "last_year", 
];
function OrdersOverview() {
    var ref19 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), data = ref19[0], setData = ref19[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), dwnldPdf = ref1[0], setDwnldPdf = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), showLoad = ref3[0], setShowLoad = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("Engar pantanir"), error = ref4[0], setError = ref4[1];
    var ref5 = (0,src_context_UserContext__WEBPACK_IMPORTED_MODULE_5__/* .useUser */ .aF)(), user = ref5.user, currentCompany = ref5.currentCompany;
    var width = (0,react_use__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)().width;
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("all"), sortBy = ref6[0], setSortBy = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("all"), sortOpt = ref7[0], setSortOpt = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("Allt"), sortText = ref8[0], setSortText = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isModalOpen = ref9[0], setIsModalOpen = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showDropdown = ref10[0], setShowDropdown = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), startDate = ref11[0], setStartDate = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), endDate = ref12[0], setEndDate = ref12[1];
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), cursor1 = ref13[0], setCursor = ref13[1];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var formatDate = function(date) {
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, "0");
        var day = String(date.getDate()).padStart(2, "0");
        return "".concat(year, "-").concat(month, "-").concat(day);
    };
    var closeModal = function() {
        setIsModalOpen(false);
    };
    var getReceipt = function(receiptId) {
        setDwnldPdf(receiptId);
        src_api_rest__WEBPACK_IMPORTED_MODULE_6__/* .restApi.receiptsPdfRetrieve */ ._O.receiptsPdfRetrieve(receiptId).then(function(resp) {
            resp.blob().then(function(blob) {
                var fileURL = window.URL.createObjectURL(blob);
                var alink = document.createElement("a");
                alink.href = fileURL;
                // alink.target = '_blank'
                alink.download = "".concat(receiptId, ".pdf");
                // Append the link to the document (required for Safari)
                document.body.appendChild(alink);
                alink.click();
                // Remove the link from the document after the download
                document.body.removeChild(alink);
                setDwnldPdf("");
            });
        }).catch(function(err) {
            console.log({
                err: err
            });
            setDwnldPdf(receiptId);
        });
    };
    var fetchOrders = function(param) {
        var ssn = param.ssn, nav_id = param.nav_id, sortby = param.sortby, start_date = param.start_date, end_date = param.end_date, // eslint-disable-next-line @typescript-eslint/no-shadow
        cursor = param.cursor;
        setLoading(true);
        src_api_rest__WEBPACK_IMPORTED_MODULE_6__/* .restApi.receiptsList */ ._O.receiptsList({
            ssn: ssn,
            nav_id: nav_id,
            sortby: sortby,
            start_date: start_date,
            end_date: end_date,
            cursor: cursor
        })// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then(function(response) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (response.data["@odata.nextLink"]) {
                setShowLoad(true);
                var token = response.data["@odata.nextLink"].split("skiptoken=")[1];
                if (token) {
                    setCursor(token);
                }
            } else {
                setCursor(null);
                setShowLoad(false);
            }
            setData(function(prev) {
                if (!prev || !(prev === null || prev === void 0 ? void 0 : prev.length)) {
                    return response.data.value;
                }
                return _toConsumableArray(prev).concat(_toConsumableArray(response.data.value));
            });
        }).then(function() {
            setLoading(false);
        }).catch(function(err) {
            console.log({
                err: err
            });
            setLoading(false);
        });
    };
    var addQueryParam = function(key, value) {
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.set(key, value);
        // Replace the current URL with the new one containing the updated query parameters
        var newUrl = "".concat(window.location.pathname, "?").concat(searchParams.toString());
        window.history.replaceState({}, "", newUrl);
    };
    var loadCustomDates = function(firstDay, lastDay, filter) {
        setSortBy(filter);
        setData(null);
        setSortOpt(filter);
        setShowLoad(true);
        if (((currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.ssn) || (user === null || user === void 0 ? void 0 : user.verified.ssn)) && firstDay && lastDay) {
            fetchOrders({
                ssn: (currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.ssn) || (user === null || user === void 0 ? void 0 : user.verified.ssn) || "",
                nav_id: currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.navId,
                sortby: "custom_range",
                start_date: firstDay,
                end_date: lastDay
            });
            setIsModalOpen(false);
        }
        if (filter === "custom_range") {
            var ref, ref14, ref15, ref16, ref17, ref18;
            var text = "Allt: ".concat((ref = startDate) === null || ref === void 0 ? void 0 : ref.getDate(), " ").concat(startDate && src_const__WEBPACK_IMPORTED_MODULE_18__/* .monthNames */ .lQ[(ref14 = startDate) === null || ref14 === void 0 ? void 0 : ref14.getMonth()], " ").concat((ref15 = startDate) === null || ref15 === void 0 ? void 0 : ref15.getFullYear(), " - ").concat((ref16 = endDate) === null || ref16 === void 0 ? void 0 : ref16.getDate(), " ").concat(endDate && src_const__WEBPACK_IMPORTED_MODULE_18__/* .monthNames */ .lQ[(ref17 = endDate) === null || ref17 === void 0 ? void 0 : ref17.getMonth()], " ").concat((ref18 = endDate) === null || ref18 === void 0 ? void 0 : ref18.getFullYear());
            setSortText(text);
        }
    };
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    var getQueryParam = function(key) {
        var searchParams = new URLSearchParams(window.location.search);
        return searchParams.get(key);
    };
    var loadDates = function(filter) {
        addQueryParam("sortby", filter);
        var currentDate = new Date();
        var year = currentDate.getFullYear();
        var month = currentDate.getMonth() + 1;
        var dateText = function(firstDay, lastDay) {
            return "Allt: ".concat(firstDay.getDate(), " ").concat(src_const__WEBPACK_IMPORTED_MODULE_18__/* .monthNames */ .lQ[firstDay.getMonth()], " ").concat(firstDay.getFullYear(), " - ").concat(lastDay.getDate(), " ").concat(src_const__WEBPACK_IMPORTED_MODULE_18__/* .monthNames */ .lQ[lastDay.getMonth()], " ").concat(lastDay.getFullYear());
        };
        if (filter === "this_month") {
            var firstDay6 = new Date(year, month - 1, 1);
            var lastDay6 = new Date(year, month, 0);
            setStartDate(firstDay6);
            setEndDate(lastDay6);
            loadCustomDates(formatDate(firstDay6), formatDate(lastDay6), filter);
            var text = dateText(firstDay6, lastDay6);
            setSortText(text);
        } else if (filter === "last_month") {
            var previousMonth = month === 1 ? 12 : month - 1;
            var previousYear = month === 1 ? year - 1 : year;
            var firstDay1 = new Date(previousYear, previousMonth - 1, 1);
            var lastDay1 = new Date(year, month - 1, 0);
            setStartDate(firstDay1);
            setEndDate(lastDay1);
            loadCustomDates(formatDate(firstDay1), formatDate(lastDay1), filter);
            var text1 = dateText(firstDay1, lastDay1);
            setSortText(text1);
        } else if (filter === "last_three_months") {
            var firstDateOfCurrentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
            var firstDay2 = new Date(firstDateOfCurrentMonth);
            firstDay2.setMonth(firstDateOfCurrentMonth.getMonth() - 3);
            var lastDay2 = new Date(firstDateOfCurrentMonth);
            lastDay2.setDate(lastDay2.getDate() - 1);
            setStartDate(firstDay2);
            setEndDate(lastDay2);
            var text2 = dateText(firstDay2, lastDay2);
            setSortText(text2);
            loadCustomDates(formatDate(firstDay2), formatDate(lastDay2), filter);
        } else if (filter === "last_six_months") {
            var firstDateOfCurrentMonth1 = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
            var firstDay3 = new Date(firstDateOfCurrentMonth1);
            firstDay3.setMonth(firstDateOfCurrentMonth1.getMonth() - 6);
            var lastDay3 = new Date(firstDateOfCurrentMonth1);
            lastDay3.setDate(lastDay3.getDate() - 1);
            setStartDate(firstDay3);
            setEndDate(lastDay3);
            var text3 = dateText(firstDay3, lastDay3);
            setSortText(text3);
            loadCustomDates(formatDate(firstDay3), formatDate(lastDay3), filter);
        } else if (filter === "this_year") {
            var currentYear = currentDate.getFullYear();
            var firstDay4 = new Date(currentYear, 0, 1);
            var lastDay4 = new Date(currentYear, 11, 31);
            setStartDate(firstDay4);
            setEndDate(lastDay4);
            var text4 = dateText(firstDay4, lastDay4);
            setSortText(text4);
            loadCustomDates(formatDate(firstDay4), formatDate(lastDay4), filter);
        } else if (filter === "last_year") {
            var currentYear1 = currentDate.getFullYear();
            var previousYear1 = currentYear1 - 1;
            var firstDay5 = new Date(previousYear1, 0, 1);
            // Get the ending date of the previous year
            var lastDay5 = new Date(previousYear1, 11, 31);
            setStartDate(firstDay5);
            setEndDate(lastDay5);
            var text5 = dateText(firstDay5, lastDay5);
            setSortText(text5);
            loadCustomDates(formatDate(firstDay5), formatDate(lastDay5), filter);
        }
        setShowDropdown(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // orders made as user
        setData(null);
        if (getQueryParam("sortby") && getQueryParam("sortby") !== "all") {
            loadDates(getQueryParam("sortby"));
            return;
        }
        if (!currentCompany && (user === null || user === void 0 ? void 0 : user.verified.ssn)) {
            // eslint-disable-next-line consistent-return
            return fetchOrders({
                ssn: user === null || user === void 0 ? void 0 : user.verified.ssn,
                sortby: "all"
            });
        }
        if (currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.ssn) {
            // eslint-disable-next-line consistent-return
            return fetchOrders({
                ssn: currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.ssn,
                nav_id: currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.navId,
                sortby: "all"
            });
        }
        // eslint-disable-next-line consistent-return
        return setError("\xd3gilt fyrirt\xe6ki");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentCompany,
        user
    ]);
    var convertDate = function(date) {
        var dataArr = date.split("-");
        if (dataArr.length) {
            var convertedDate = dataArr.reverse().join("/");
            return convertedDate;
        }
        return "-";
    };
    var LoadMore = function() {
        if ((data === null || data === void 0 ? void 0 : data.length) && ((currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.ssn) || (user === null || user === void 0 ? void 0 : user.verified.ssn))) {
            fetchOrders({
                ssn: (currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.ssn) || (user === null || user === void 0 ? void 0 : user.verified.ssn) || "",
                nav_id: currentCompany ? currentCompany.navId : undefined,
                cursor: cursor1 || undefined,
                end_date: sortBy === "all" ? undefined : endDate ? formatDate(endDate) : undefined,
                start_date: sortBy === "all" ? undefined : startDate ? formatDate(startDate) : undefined,
                sortby: sortBy || "all"
            });
        }
    };
    var customRange = function() {
        setStartDate(null);
        setEndDate(null);
        setIsModalOpen(true);
    };
    var LoadSort = function(sortType, sort) {
        setSortBy(sortType);
        setData(null);
        setSortOpt(sort);
        setSortText(sort);
        setShowLoad(true);
        setShowDropdown(false);
        addQueryParam("sortby", "all");
        if (((currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.ssn) || (user === null || user === void 0 ? void 0 : user.verified.ssn)) && sortType === "custom_range") {
            fetchOrders({
                ssn: (currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.ssn) || (user === null || user === void 0 ? void 0 : user.verified.ssn) || "",
                nav_id: currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.navId,
                sortby: sortType,
                start_date: formatDate(startDate),
                end_date: formatDate(endDate)
            });
            setIsModalOpen(false);
        } else if ((currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.ssn) || (user === null || user === void 0 ? void 0 : user.verified.ssn)) {
            fetchOrders({
                ssn: (currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.ssn) || (user === null || user === void 0 ? void 0 : user.verified.ssn) || "",
                nav_id: currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.navId,
                sortby: sortType
            });
        }
    };
    var SortContainer = function() {
        var dropDownRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
        (0,react_use__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(dropDownRef, function() {
            setShowDropdown(false);
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SortDropdown, {
            ref: dropDownRef,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                    type: "button",
                    className: "sort-button",
                    onClick: function() {
                        return setShowDropdown(!showDropdown);
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/icons/sortCalendarIcon.svg",
                                    alt: "calendar Icon",
                                    width: 16,
                                    height: 16,
                                    className: "sort-calendar-icon"
                                }),
                                sortText
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: showDropdown ? "arrow up" : "arrow down"
                        })
                    ]
                }),
                showDropdown && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "options",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    onClick: function() {
                                        return LoadSort("all", "Allt");
                                    },
                                    className: sortOpt === "all" ? "selected" : "",
                                    disabled: getQueryParam("sortby") === "all" && sortBy !== "custom_range",
                                    children: options.all
                                })
                            }),
                            dateOptions.map(function(option) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        type: "button",
                                        onClick: function() {
                                            return loadDates(option);
                                        },
                                        className: sortOpt === option ? "selected" : "",
                                        disabled: getQueryParam("sortby") === option,
                                        children: options[option]
                                    })
                                });
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    onClick: customRange,
                                    className: sortOpt === "custom_range" ? "selected" : "",
                                    children: options.custom_range
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var Modal = function(param) {
        var isOpen = param.isOpen, onClose = param.onClose, children = param.children;
        if (!isOpen) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalOverlay, {
            onClick: onClose,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalContent, {
                onClick: function(e) {
                    return e.stopPropagation();
                },
                children: children
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrdersContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "heading-sort",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_typography_index__WEBPACK_IMPORTED_MODULE_8__.H5, {
                        children: "Reikningar"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SortContainer, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "orders-conatiner",
                children: loading && !(data === null || data === void 0 ? void 0 : data.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "loader",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_common_Loader__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: data && data.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "orders-table",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_12__.Row, {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_12__.Col, {
                                                col: width > 750 ? 2 : 3,
                                                className: "column header",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "align",
                                                    children: "P\xf6ntun"
                                                })
                                            }),
                                            width > 750 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_12__.Col, {
                                                col: 2,
                                                className: "column header",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "align",
                                                    children: "Dagsetning"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_12__.Col, {
                                                col: width > 750 ? 3 : 4,
                                                className: "column header",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "align",
                                                    children: "Nafn vi\xf0skiptavinar"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_12__.Col, {
                                                col: width > 750 ? 3 : 4,
                                                className: "column header",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "align",
                                                    children: "Samtals me\xf0 VSK"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_12__.Col, {
                                                col: 1,
                                                className: "column header",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "align"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: data.map(function(order) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_12__.Row, {
                                                className: "row table-row",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_12__.Col, {
                                                        col: width > 750 ? 2 : 3,
                                                        className: "column",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "align",
                                                            children: order.Order_No
                                                        })
                                                    }),
                                                    width > 750 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_12__.Col, {
                                                        col: width > 750 ? 2 : 4,
                                                        className: "column",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "align",
                                                            children: convertDate(order.Document_Date)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_12__.Col, {
                                                        col: width > 750 ? 3 : 4,
                                                        className: "column",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "align",
                                                            children: order.SellTo_Customer_Name
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_12__.Col, {
                                                        col: width > 750 ? 3 : 4,
                                                        className: "column",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "align",
                                                            children: "".concat((0,src_utils_numbers__WEBPACK_IMPORTED_MODULE_10__/* .formatNumber */ .uf)(Number(order.Amount_Including_VAT)), " kr.")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_12__.Col, {
                                                        col: 1,
                                                        className: "column",
                                                        children: dwnldPdf !== order.No ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                            className: "download-button",
                                                            type: "button",
                                                            onClick: function() {
                                                                return getReceipt(order.No);
                                                            },
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_FileDownloadLineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                                size: width > 750 ? 30 : 20
                                                            })
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "loader",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_common_Loader__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                                                        })
                                                    })
                                                ]
                                            }, order.No);
                                        })
                                    })
                                ]
                            }),
                            loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "loader",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_common_Loader__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                            }),
                            showLoad && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "load_button",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_buttons__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .zx, {
                                    onClick: LoadMore,
                                    disabled: loading,
                                    withGutter: true,
                                    outlined: true,
                                    children: "Hla\xf0a meira"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "message_box",
                        children: error
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Modal, {
                    isOpen: isModalOpen,
                    onClose: closeModal,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "date-heading",
                            children: "Veldu t\xedmabil"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "date-section",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Byrjar \xe1:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_date_picker__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                    calendarIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                        src: "/icons/calendarIcon.svg",
                                        alt: "calendar Icon",
                                        width: 25,
                                        height: 25,
                                        className: "calendar-icon"
                                    }),
                                    onChange: setStartDate,
                                    value: startDate
                                }),
                                startDate && startDate > new Date() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "date-error-text",
                                    children: "\xdeetta t\xedmabil er \xf3gilt"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "date-section",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Endar \xe1:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_date_picker__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                    calendarIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                        src: "/icons/calendarIcon.svg",
                                        alt: "calendar Icon",
                                        width: 25,
                                        height: 25,
                                        className: "calendar-icon"
                                    }),
                                    onChange: setEndDate,
                                    value: endDate
                                }),
                                startDate && endDate && startDate > endDate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "date-error-text",
                                    children: "\xdeetta t\xedmabil er \xf3gilt"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "btns-container",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    onClick: function() {
                                        return setIsModalOpen(false);
                                    },
                                    children: "H\xe6tta vi\xf0"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    disabled: !startDate || !endDate,
                                    onClick: function() {
                                        return loadCustomDates(formatDate(startDate), formatDate(endDate), "custom_range");
                                    },
                                    children: "\xc1fram"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "close-button",
                            onClick: closeModal,
                            children: "X"
                        })
                    ]
                })
            })
        ]
    });
};


/***/ })

}]);